"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var service_service_1 = require("./../../../Services/service.service");
var conversationService_1 = require("./../../../Services/conversationService");
var router_1 = require("@angular/router");
var core_2 = require("@angular/core");
var ChatComponent = /** @class */ (function () {
    function ChatComponent(mainService, route, conversationService) {
        this.mainService = mainService;
        this.route = route;
        this.conversationService = conversationService;
        this.submitClick = new core_2.EventEmitter();
        this.showUserList = true;
        this.userListCollapsed = false;
        this.acceptTermsEnable = false;
        this.newConv = false;
        this.activeGroup = null; // dodane testowo na sztywno
        this.changesHelper = true;
        var urlId = this.route.snapshot.paramMap.get('id');
        this.activeConversationId = parseInt(urlId);
        if (urlId) {
            this.mainService.showLoader();
        }
        this.getUrlConversation();
    }
    ChatComponent.prototype.onPopState = function (event) {
        this.getUrlConversation();
    };
    ChatComponent.prototype.ngOnInit = function () {
        if (this.newConversationAdvId) {
            this.newConv = true;
        }
    };
    ChatComponent.prototype.getUrlConversation = function () {
        var _this = this;
        if (this.activeConversationId) {
            this.conversationService.getConversation(this.activeConversationId).then(function (result) {
                _this.activeGroup = result;
                _this.mainService.hideLoader();
            });
        }
        else {
            this.activeGroup = null;
        }
    };
    ChatComponent.prototype.activateGroup = function (group) {
        var newUrl = "conversations/" + group.conversationId;
        window.history.pushState({ pageTitle: "conversations" }, "", newUrl);
        this.activeGroup = group;
    };
    ChatComponent.prototype.reloadMessages = function (conversation) {
        this.activeGroup.messages = conversation.messages;
        this.conversationService.setReadedMessages(conversation.conversationId, conversation.messages.map(function (c) { return c.conversationMessageId; }));
        this.changesHelper = !this.changesHelper;
        this.scrollToBottom();
    };
    ChatComponent.prototype.scrollToBottom = function () {
        var lastMsgRef = document.querySelectorAll(".vng-chat-message:last-child")[0];
        if (lastMsgRef)
            lastMsgRef.scrollIntoView();
    };
    ChatComponent.prototype.fireInitialConversationMessage = function (message) {
        this.submitClick.emit(message);
    };
    return ChatComponent;
}());
exports.ChatComponent = ChatComponent;
